import { IntlProvider } from 'react-intl';
import { HashRouter, Route, Routes } from 'react-router';

import { DEFAULT_LOCALE } from '../../configuration/lang/lang';
import { getDisplayMessages, getLocale } from '../../configuration/lang/langSlice';
import { useAppSelector } from '../../configuration/setup/hooks';
import Recommendations from './Recommendations';
import UpsellingWrapper from './UpsellingWrapper';

const App = () => {
    const userLocale = useAppSelector(getLocale);
    const displayMessages = useAppSelector(getDisplayMessages);

    if (!displayMessages || !userLocale) {
        return null;
    }

    return (
        <IntlProvider defaultLocale={DEFAULT_LOCALE} key={userLocale} locale={userLocale} messages={displayMessages}>
            <HashRouter basename=''>
                <Routes>
                    <Route path='recommendations' element={<Recommendations />} />
                    <Route path='*' element={<UpsellingWrapper />} />
                </Routes>
            </HashRouter>
        </IntlProvider>
    );
};

export default App;
